/*
import firebaseNotif from 'react-native-firebase';
export default firebaseNotif;

*/

export default {
  demoMode:true, 
  showImagePicker: function() {
    return {didCancel:true};
  },
}

